export class ExceptionHandler {
    static handle(e) {
        console.error('Uncatched Exception', e);
    }
    static RejectedPromise(reason) {
        console.error('Uncatched Rejected Promise', reason);
    }
}
